module.exports = __webpack_public_path__ + "static/8(2)-c1b7f516334ae069056286402c8f7508.jpg";